import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";

export function locationsErrorMessageForRequiredField(
  field: string | undefined,
): ErrorMessageType {
  if (field === undefined || field === "") {
    return "Required";
  }

  return undefined;
}
